import _ from "underscore"
import { isNotEmpty, isEmpty } from "../../framework/utils"
import { COMPUTATION_TYPES } from "../../model/vars";
import M from "../../strings";
import { format, optional, walk } from "../../utils/lang"

export function formatObservations(score) {
    const {answeredQuestions, totalQuestions} = score;
    
    if (isNotEmpty(answeredQuestions)) {
        return format(M("surveyProgress"), answeredQuestions, totalQuestions)
    } else {
        return 0;
    }
}

export function gradeScore(score) {
    if (isEmpty(score)) {
        return 0
    } else {
        const _score = parseFloat(score);

        if (isNaN(_score)) {
            return 0
        } else if (score < 60) {
            return 2
        } else if (score < 70) {
            return 3
        } else if (score < 80) {
            return 4
        } else {
            return 5
        }
    }
}

export function gradeRating(score) {
    const parsedScore = optional(() => Math.round(parseFloat(score)), 0) ;
    return !isNaN(parsedScore) ? parsedScore : 0;
}

export function gradeTrend(trend) {
    let grade = 0;

    if (isNotEmpty(trend)) {
        const _trend = parseFloat(trend);

        if (!isNaN(_trend)) {
            if (_trend === 0) {
                return 0
            } else if (_trend < 0) {
                return 1
            } else {
                return 5
            }
        }
    }

    return grade;
}

export function getSurveyProgress(roots) {
    let questions = [];
    walk(roots, "children", c => {
        questions = questions.concat(optional(c.questions, []));
    });

    return {
        answeredQuestions: _.filter(questions, q => isNotEmpty(q.rating)).length,
        totalQuestions: questions.length,
    }

}

export function getScoreValue(score) {
    try {
        const _value = score.value ? parseFloat(score.value) : 0;
        return !isNaN(_value) ? Math.round(_value) : 0;
    } catch (e) {
        return score?.value ?? 0;
    }
}

export function getRatingValue(rating, readonly = false) {
    try {
        if (readonly) {
            return optional(() => rating.value, undefined);
        } else {
            const _value = rating.input ? parseFloat(rating.input) : undefined;
            return !isNaN(_value) ? Math.round(_value) : rating.input;
        }
    } catch (e) {
        return optional(() => rating.value, undefined);
    }
}

export function applyScores(roots, scores) {
    walk(roots, "children", c => {
        const category = c.category,
            categoryId = category.id,
            score = _.findWhere(scores, {categoryId: categoryId});

        if (isNotEmpty(score)) {
            category.score = score;
        }
    });
}

export function applyRatings(roots, ratings) {
    walk(roots, "children", c => {
        const questions = optional(c.questions, []);

        _.each(questions, q => {
            const question = q.question,
                relatedQuestions = optional(q.relatedQuestions, []),
                id = question.id,
                rating = _.findWhere(ratings, {questionId: id});

            if (isNotEmpty(rating)) {
                question.rating = rating;
            }

            _.each(relatedQuestions, rquestion => {
                const id = rquestion.id,
                    rating = _.findWhere(ratings, {questionId: id});
    
                if (isNotEmpty(rating)) {
                    rquestion.rating = rating;
                }
            })
        })

        
    });
}